import { i18n } from '@/locales';
export const fonts = [
    {
        label: i18n.global.t('text.arialSerif'),
        value: 'Arial, sans-serif',
        style: {
            fontFamily: 'Arial, sans-serif',
        },
    },
    {
        label: i18n.global.t('text.verdanaSansSerif'),
        value: 'Verdana, sans-serif',
        style: {
            fontFamily: 'Verdana, sans-serif',
        },
    },
    {
        label: i18n.global.t('text.tahomaSansSerif'),
        value: 'Tahoma, sans-serif',
        style: {
            fontFamily: 'Tahoma, sans-serif',
        },
    },
    {
        label: i18n.global.t('text.trebuchetMSSansSerif'),
        value: "'Trebuchet MS', sans-serif",
        style: {
            fontFamily: "'Trebuchet MS', sans-serif",
        },
    },
    {
        label: i18n.global.t('text.timesNewRomanSerif'),
        value: "'Times New Roman', serif",
        style: {
            fontFamily: "'Times New Roman', serif",
        },
    },
    {
        label: i18n.global.t('text.georgiaSerif'),
        value: 'Georgia, serif',
        style: {
            fontFamily: 'Georgia, serif',
        },
    },
    {
        label: i18n.global.t('text.garamondSerif'),
        value: 'Garamond, serif',
        style: {
            fontFamily: 'Garamond, serif',
        },
    },
    {
        label: i18n.global.t('text.courierNewMonospace'),
        value: "'Courier New', monospace",
        style: {
            fontFamily: "'Courier New', monospace",
        },
    },
    {
        label: i18n.global.t('text.brushScriptMTCursive'),
        value: "'Brush Script MT', cursive",
        style: {
            fontFamily: "'Brush Script MT', cursive",
        },
    },
];
export const fontSize = [
    { label: '8', value: '8' },
    { label: '9', value: '9' },
    { label: '10', value: '10' },
    { label: '11', value: '11' },
    { label: '12', value: '12' },
    { label: '14', value: '14' },
    { label: '18', value: '18' },
    { label: '24', value: '24' },
    { label: '30', value: '30' },
    { label: '36', value: '36' },
    { label: '48', value: '48' },
    { label: '60', value: '60' },
    { label: '72', value: '72' },
    { label: '96', value: '96' },
];
